export class Passwordsecuritylevel {
  id: number;
  userId: number;
  level: number;
  createAt: string;
  active: boolean;
  deleted: boolean;
}
